import * as React from "react";
import type { SVGProps } from "react";
const SvgOverviewIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="overview_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M180.139 128c-71.595 0-137.472 55.339-137.472 133.163v506.069c0 77.824 65.877 133.163 137.472 133.163h218.538a8.107 8.107 0 0 1 4.694 1.365L512 981.333l108.672-79.573a8.064 8.064 0 0 1 4.65-1.365h218.54c71.594 0 137.471-55.339 137.471-133.12V261.12c0-77.781-65.877-133.12-137.472-133.12H618.155c-8.576 0-17.152.768-25.6 2.304l-5.547 1.024L512 167.808l-75.008-36.48-5.547-1.024a142.165 142.165 0 0 0-25.6-2.304H180.14zM128 261.163c0-20.224 19.03-44.374 52.139-44.374h225.706c2.006 0 3.968.086 5.931.299l57.557 27.947v596.48L452.48 829.14a91.05 91.05 0 0 0-53.76-17.493H180.096c-33.152 0-52.139-24.192-52.139-44.373V261.12zm426.667 580.352v-596.48l57.557-27.947a60.16 60.16 0 0 1 5.93-.299h225.707c33.152 0 52.139 24.15 52.139 44.374v506.069c0 20.224-18.987 44.373-52.139 44.373H625.323c-19.03 0-37.974 5.974-53.76 17.536l-16.896 12.374z"
    />
  </svg>
);
export default SvgOverviewIcon;
